// extracted by mini-css-extract-plugin
export default {"bodyHome":"Home_bodyHome__CyHb1","spaceCharts":"Home_spaceCharts__P7zQ1"};